import instObj from '@/backend/axios-instances'

const resource = "/orders/details/boms"
const instance = instObj.baseInstance

export default {
  // get(parameters) {
  //   return instance.get(resource, { params: parameters });
  // },
  post(data, parameters) {
    // need order_id and bom_detail_id in body
    return instance.post(resource, data, { params: parameters });
  }
}
